<template>
  <div class="d-flex flex-column m-3">
    <div class="d-flex flex-row justify-content-between no-select">
      <div
        style="color: #1976d2"
        class="d-flex flex-row flex-fill justify-content-center"
      >
        <span class="pop-up-title">NVLink request</span>
      </div>
      <button type="button" @click="closeThisPopup">
        <i
          style="font-size: 1.75rem"
          class="el-icon-close button-close-popup"
        ></i>
      </button>
    </div>
    <div></div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>